import {ItemType} from "../../API";
import {createItem, CreateItemOptions} from "./createItem";
import {UndoableActionGroup} from "../common/UndoableActionGroup";
import { CrudServices } from "../../platform/services/types/ServiceDependencies";

export async function createCluster(
    services: CrudServices,
    { workspace, appState, parentId, name, noSelect }: CreateItemOptions,
    undoableActionGroup?: UndoableActionGroup
) {
    return await createItem(
        services,
        { workspace, appState, type: ItemType.CLUSTER, parentId, name, noSelect },
        undoableActionGroup
    );
}
